import styled, { css } from 'styled-components'

export const Placeholder = styled.div<{
	$flexBasis?: string,
	$flexGrow?: number,
	$flexShrink?: number
}>`
	${(props) => css`
		flex-grow: ${props.$flexGrow || 'initial'};
		flex-shrink: ${props.$flexShrink || 'initial'};
		flex-basis: ${props.$flexBasis || 'initial'};
	`}
`
